import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormAssetImprovement,
  BackendMutationImproveLongFormAssetArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ImproveLongFormAsset(
    $longFormAssetId: ID!
    $recomposeMode: RecomposeModeEnum
    $continueMode: ContinueModeEnum
    $isParagraphMode: Boolean
    $instructions: String
    $markedSegment: MarkedSegment
    $tovInput: TovInput
    $structureInstructionsData: JSON
    $onlyImproveScore: Boolean
  ) {
    improveLongFormAsset(
      longFormAssetId: $longFormAssetId
      recomposeMode: $recomposeMode
      continueMode: $continueMode
      isParagraphMode: $isParagraphMode
      instructions: $instructions
      markedSegment: $markedSegment
      tovInput: $tovInput
      structureInstructionsData: $structureInstructionsData
      onlyImproveScore: $onlyImproveScore
    ) {
      segmentHtml
      assetHtml
      assetMarkup {
        start
        end
        type
        paragraph
      }
      score
    }
  }
`;

export const improveLongFormAsset = async (
  variables: BackendMutationImproveLongFormAssetArgs
): Promise<BackendLongFormAssetImprovement | undefined> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { traceAcRequests: true },
  });
  return getSingleProp<BackendLongFormAssetImprovement>(response.data);
};
